<script>
import Vue from 'vue';
import { BarcodeGeneratorPlugin } from "@syncfusion/ej2-vue-barcode-generator";
Vue.use(BarcodeGeneratorPlugin);
export default {
    name: "PatientDetailsPrintOut",

    data() {

        return {
            patient: {},
        };
    },

    mounted() {
        Promise.allSettled([this.fetchPatient(),]).then(() => {
            window.setTimeout(() => {
                window.print();
            }, 600);
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.params.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap mt-2 border-t-2 border-b-2 border-gray-900">
            <div class="w-full p-1 text-center">
                <h5 class="font-bold text-base">{{ patient.names }}</h5>
            </div>
            <div class="w-1/2 p-1">
                <h5 class="font-bold text-sm">OPFileNO: {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="w-1/2 p-1">
                <h5 class="font-bold text-sm">IPFileNO: {{ patient.ipfileno || `-` }}</h5>
            </div>
            <div class="w-1/2 p-1">
                <h5 class="font-bold text-sm">Gender: {{ patient.gender }}</h5>
            </div>
            <div class="w-1/2 p-1">
                <h5 class="font-bold text-sm">Phone: {{ patient.celL_PHONE || " -" }}</h5>
            </div>
        </div>
        <div class="w-full mt-2 p-1">
            <ejs-barcodegenerator
              id="barcode"
              invalid="invalidInput"
              ref="barcodeControl"
              :width="`200px`"
              :height="`100px`"
              :type="`Code128A`"
              :value="patient.patienT_ID || `-`"
              :mode="`SVG`"
            ></ejs-barcodegenerator>
        </div>
    </div>
</template>